export enum InfoSectionType {
  TEXT = 'text',
  VENUE_ADDRESS = 'venue_address',
  WEBSITE = 'website',
  CONTACT = 'contact',
  TRAVEL = 'travel',
  PARKING = 'parking',
  TOILETS = 'toilets',
  FOOD_AND_DRINKS = 'food_and_drinks',
  ACCESSIBILITY = 'accessibility',
  FAQ = 'faq',
}

export interface InfoSection {
  uid: string
  section_type: InfoSectionType
  icon_code: string | null
  heading: string | null
  body: string | null
  body_doc: string | null
  enabled: boolean
  y_axis: number
}
